import React from 'react';

import { Typography } from '@vk-hr-tek/ui/Typography';
import { Box } from '@vk-hr-tek/ui/Box';

import { NotificationGroup } from '../../types';
import { NotificationItem, NotificationItemProps } from '../NotificationItem';

import { useStyles } from './NotificationGroupItem.styles';

interface NotificationGroupItemProps
  extends Omit<NotificationItemProps, 'data'> {
  data: NotificationGroup;
  onClose?: () => void;
}

export const NotificationGroupItem = ({
  data,
  variant = 'list',
  onClose,
  ...restProps
}: NotificationGroupItemProps) => {
  const { classes } = useStyles();

  const isWidgetVariant = variant === 'widget';

  if (data.type === 'group') {
    return (
      <Box
        className={classes.groupLabelWrapper}
        my={isWidgetVariant ? '0' : '4'}
      >
        <Typography
          variant={isWidgetVariant ? 'subtitle2' : 'body2'}
          color="text.light.tertirary"
        >
          {data.label}
        </Typography>
      </Box>
    );
  }

  return (
    <NotificationItem
      data={data}
      variant={variant}
      onClose={onClose}
      {...restProps}
    />
  );
};
